import { Skeleton, TableCell, TableRow } from '@mui/material';
import React from 'react';


const LoadingTableRow = () => {
  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton width={'50%'} height={20} />
      </TableCell>
    </TableRow>);
};

export default LoadingTableRow;
